// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DropdownLinks{background-color:#fff;border:1px solid #f4f4f4;min-width:10rem;position:relative;top:.375rem}.DropdownLinks:before{border:1px solid #fff;bottom:-2px;content:\"\";display:block;left:-2px;position:absolute;right:-2px;top:-2px}.DropdownLinks__item{color:#282829;display:block;padding:.5rem;position:relative}.DropdownLinks__item:focus,.DropdownLinks__item:hover{background-color:#f4f4f4;color:#282829}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
